const options = {
  border: "bg-clip-border",
  content: "bg-clip-content",
  padding: "bg-clip-padding",
  text: "bg-clip-text",
};

export default function getBackgroundClip(clip) {
  return options[clip];
}